import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Extra,
  Para,
  Empty,
  Language
} from "./styles";


const Footer = ({ t }: { t: TFunction }) => {


  return (
    <>
      <FooterSection id="footer">
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>{t("Address")}</Language>
              <Para>Registered Office</Para>
              <Para>Zenonos Pieride 24,</Para>
              <Para>Lamanko Center, office 108,</Para>
              <Para>6023 Larnaka, Cyprus</Para>
              <Para><a href="mailto:contact@aplissan.com">contact@aplissan.com</a></Para>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <a href="https://gluwell.com/money-back-policy">Refund or cancellation policy</a>
            <a href="https://gluwell.com/privacy-policy">Privacy Policy</a>
            <a href="https://gluwell.com/terms-of-use">Terms Of Use</a>
            <a href="https://aplissan.com">&copy; 2024  Aplissan Company LTD</a>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
